import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authoring.adjudications');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-authoring-adjudications',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authoring.adjudications/view.scss */
:host {
  display: block;
  height: 100%;
}

.adjudication-page {
  max-width: 1220px;
  margin: 0 auto;
  padding: 34px 32px 60px;
}

.page-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
}

.page-heading span, .resolution-editor > header span, .resolution-summary span {
  color: #646bab;
  font-size: 8px;
  font-weight: 850;
  letter-spacing: 0.13em;
}

.page-heading h1 {
  margin: 6px 0 0;
  color: #292c46;
  font-size: 25px;
  letter-spacing: -0.035em;
}

.page-heading p {
  margin: 8px 0 0;
  color: #85879a;
  font-size: 10px;
}

.page-heading > button {
  padding: 8px 11px;
  border: 1px solid #dfe0e8;
  border-radius: 8px;
  color: #5c6077;
  background: #fff;
  font-family: inherit;
  font-size: 9px;
}

.boundary-notice {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding: 13px 15px;
  border-radius: 10px;
  color: #4f568b;
  background: #f0f1fa;
  gap: 18px;
}

.boundary-notice strong {
  font-size: 8px;
  letter-spacing: 0.1em;
  white-space: nowrap;
}

.boundary-notice p {
  margin: 0;
  font-size: 8px;
}

.batch-selector {
  display: flex;
  align-items: flex-end;
  margin-top: 16px;
  padding: 15px;
  border: 1px solid #dedfe8;
  border-radius: 12px;
  background: #fff;
  gap: 16px;
}

.batch-selector label span {
  display: block;
  margin-bottom: 6px;
  color: #8a8c9d;
  font-size: 8px;
}

.batch-selector select {
  min-width: 300px;
  padding: 9px 30px 9px 10px;
  border: 1px solid #dfe0e8;
  border-radius: 8px;
  color: #404359;
  background: #fff;
  font-family: inherit;
  font-size: 9px;
}

.batch-metrics {
  display: flex;
  align-items: center;
  gap: 12px;
}

.batch-metrics span {
  color: #9293a2;
  font-size: 8px;
}

.batch-metrics strong {
  margin-left: 3px;
  color: #4d5068;
  font-size: 10px;
}

.close-button {
  margin-left: auto;
  padding: 10px 13px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  background: #535b98;
  font-family: inherit;
  font-size: 9px;
  font-weight: 750;
}

.close-button:disabled {
  opacity: 0.4;
}

.state-card {
  margin-top: 16px;
  padding: 40px;
  border: 1px dashed #d8d9e3;
  border-radius: 12px;
  color: #797b8f;
  background: #fafafd;
  text-align: center;
}

.state-card strong {
  display: block;
  color: #45485f;
  font-size: 11px;
}

.state-card p {
  margin: 7px 0 0;
  font-size: 8px;
}

.item-list {
  display: grid;
  margin-top: 16px;
  gap: 14px;
}

.adjudication-item {
  padding: 17px;
  border: 1px solid #dedfe8;
  border-radius: 13px;
  background: #fff;
}

.adjudication-item[data-state=CONFLICT], .adjudication-item[data-state=HOLD] {
  border-color: #dacda8;
  box-shadow: 0 5px 18px rgba(116, 93, 45, 0.07);
}

.adjudication-item > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.adjudication-item > header > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.adjudication-item > header span {
  color: #646bab;
  font-size: 8px;
  font-weight: 850;
}

.adjudication-item > header em {
  padding: 4px 7px;
  border-radius: 5px;
  color: #8e673c;
  background: #fff5df;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.adjudication-item[data-state=AGREED] > header em, .adjudication-item[data-state=RESOLVED] > header em {
  color: #477769;
  background: #eaf6f1;
}

.adjudication-item > header small {
  color: #9698a7;
  font-size: 8px;
}

.qa-source {
  display: grid;
  margin-top: 13px;
  grid-template-columns: 1.25fr 0.75fr;
  gap: 12px;
}

.qa-source > div, .qa-source aside {
  padding: 13px;
  border-radius: 9px;
  background: #f8f8fb;
}

.qa-source small, .qa-source aside span {
  color: #777ca5;
  font-size: 7px;
  font-weight: 850;
  letter-spacing: 0.1em;
}

.qa-source h2 {
  margin: 6px 0 12px;
  color: #34374e;
  font-size: 13px;
  line-height: 1.5;
}

.qa-source p {
  margin: 6px 0 0;
  color: #525568;
  font-size: 9px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.decision-compare {
  display: grid;
  margin-top: 12px;
  grid-template-columns: repeat(2, 1fr);
  gap: 9px;
}

.decision-compare > article {
  padding: 12px;
  border: 1px solid #e1e2ea;
  border-radius: 9px;
}

.decision-compare header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.decision-compare header strong, .decision-compare header small {
  display: block;
}

.decision-compare header strong {
  color: #44475d;
  font-size: 9px;
}

.decision-compare header small {
  margin-top: 2px;
  color: #9b9ca9;
  font-size: 7px;
}

.decision-compare header em {
  padding: 4px 6px;
  border-radius: 5px;
  color: #505990;
  background: #eceefa;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.decision-compare header em[data-decision=REJECT] {
  color: #9b4d4d;
  background: #fff0f0;
}

.decision-compare header em[data-decision=HOLD] {
  color: #8b6b39;
  background: #fff7e7;
}

.decision-compare > article > p {
  margin: 8px 0 0;
  color: #77798a;
  font-size: 8px;
}

.annotation-preview {
  display: flex;
  flex-wrap: wrap;
  margin: 8px 0 0;
  gap: 5px;
}

.annotation-preview > div {
  display: flex;
  padding: 4px 6px;
  border-radius: 5px;
  background: #f2f3f8;
  gap: 4px;
}

.annotation-preview dt {
  color: #9294a5;
  font-size: 7px;
}

.annotation-preview dd {
  margin: 0;
  color: #5b5f78;
  font-size: 7px;
  font-weight: 750;
}

.revision-preview {
  margin-top: 9px;
  padding: 9px;
  border-radius: 7px;
  background: #f4f4f8;
}

.revision-preview span, .revision-preview strong {
  display: block;
}

.revision-preview span {
  color: #777ca7;
  font-size: 7px;
}

.revision-preview strong {
  margin-top: 5px;
  color: #44475d;
  font-size: 8px;
}

.revision-preview p {
  margin: 5px 0 0;
  color: #66697b;
  font-size: 8px;
  line-height: 1.55;
}

.agreement-state, .resolution-summary {
  margin-top: 12px;
  padding: 11px 12px;
  border-radius: 8px;
  color: #496f64;
  background: #edf7f3;
}

.agreement-state strong {
  font-size: 9px;
}

.agreement-state p {
  margin: 3px 0 0;
  font-size: 8px;
}

.resolution-summary {
  display: flex;
  align-items: center;
  gap: 12px;
}

.resolution-summary > div strong {
  display: block;
  margin-top: 3px;
  font-size: 9px;
}

.resolution-summary p {
  margin: 0;
  color: #687d76;
  font-size: 8px;
}

.resolution-summary small {
  margin-left: auto;
  color: #84968f;
  font-size: 7px;
}

.resolution-editor {
  margin-top: 12px;
  padding: 13px;
  border: 1px solid #dedfe8;
  border-radius: 9px;
}

.resolution-editor > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.resolution-editor > header span, .resolution-editor > header strong {
  display: block;
}

.resolution-editor > header strong {
  margin-top: 3px;
  color: #44475d;
  font-size: 10px;
}

.resolution-editor > header em {
  color: #9798a7;
  font-size: 7px;
  font-style: normal;
}

.final-options {
  display: grid;
  margin-top: 10px;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
}

.final-options button {
  padding: 9px;
  border: 1px solid #dedfe8;
  border-radius: 7px;
  color: #66697c;
  background: #fff;
  font-family: inherit;
  font-size: 8px;
}

.final-options button.selected {
  border-color: #5c66a3;
  color: #424b88;
  background: #eef0fa;
  box-shadow: inset 0 0 0 1px #5c66a3;
}

.final-options button.selected[data-decision=REJECT] {
  border-color: #b76565;
  color: #9d4646;
  background: #fff1f1;
  box-shadow: inset 0 0 0 1px #b76565;
}

.revision-select, .comment-input {
  display: block;
  margin-top: 11px;
}

.revision-select > span, .comment-input > span, .reason-select > span {
  display: block;
  margin-bottom: 6px;
  color: #6c6f82;
  font-size: 8px;
  font-weight: 750;
}

.revision-select em, .comment-input em, .reason-select em {
  color: #a14f4f;
  font-size: 7px;
  font-style: normal;
}

.revision-select select, .comment-input textarea {
  box-sizing: border-box;
  width: 100%;
  padding: 9px;
  border: 1px solid #dfe0e8;
  border-radius: 7px;
  color: #44475b;
  background: #fff;
  font-family: inherit;
  font-size: 8px;
}

.comment-input textarea {
  resize: vertical;
  line-height: 1.6;
}

.annotation-select {
  margin-top: 11px;
  padding: 10px;
  border: 1px solid #dfe2ef;
  border-radius: 8px;
  background: #f7f8fc;
}

.annotation-select > header {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.annotation-select > header span {
  color: #646bab;
  font-size: 7px;
  font-weight: 850;
}

.annotation-select > header small {
  color: #8d90a4;
  font-size: 7px;
}

.annotation-select > div {
  display: grid;
  margin-top: 8px;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
}

.annotation-select label > span {
  display: block;
  margin-bottom: 5px;
  color: #6c6f82;
  font-size: 8px;
  font-weight: 750;
}

.annotation-select label em {
  color: #a14f4f;
  font-size: 7px;
  font-style: normal;
}

.annotation-select select {
  box-sizing: border-box;
  width: 100%;
  height: 34px;
  padding: 0 8px;
  border: 1px solid #dfe0e8;
  border-radius: 7px;
  color: #44475b;
  background: #fff;
  font-family: inherit;
  font-size: 8px;
}

.reason-select {
  margin-top: 11px;
  padding: 10px;
  border-radius: 8px;
  background: #faf7f1;
}

.reason-select > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.reason-select button {
  padding: 5px 8px;
  border: 1px solid #ded9ce;
  border-radius: 99px;
  color: #777265;
  background: #fff;
  font-family: inherit;
  font-size: 7px;
}

.reason-select button.selected {
  color: #66563d;
  background: #f1e8d7;
  font-weight: 750;
}

.resolution-editor footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.resolution-editor footer button {
  padding: 9px 12px;
  border: 0;
  border-radius: 7px;
  color: #fff;
  background: #535b98;
  font-family: inherit;
  font-size: 8px;
  font-weight: 750;
}

.resolution-editor button:disabled {
  opacity: 0.45;
}

@media (max-width: 760px) {
  .adjudication-page {
    padding: 26px 18px 44px;
  }
  .batch-selector {
    align-items: stretch;
    flex-direction: column;
  }
  .batch-selector select {
    width: 100%;
    min-width: 0;
  }
  .close-button {
    margin-left: 0;
  }
  .qa-source, .decision-compare {
    grid-template-columns: 1fr;
  }
  .final-options {
    grid-template-columns: 1fr;
  }
  .resolution-summary {
    align-items: flex-start;
    flex-direction: column;
  }
  .resolution-summary small {
    margin-left: 0;
  }
  .annotation-select > div {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageAuthoringAdjudicationsComponent implements OnInit {
    public loading: boolean = true;
    public savingCandidateId: string = '';
    public closing: boolean = false;
    public batches: any[] = [];
    public items: any[] = [];
    public selectedBatchId: string = '';
    public policy: any = {};
    public canClose: boolean = false;
    public forms: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public currentDataset() {
        return this.service.auth.session.current_dataset || {};
    }

    public canAdjudicate() {
        let roles = this.currentDataset().roles || [];
        return this.service.auth.session.user_type === 'SYSTEM_ADMIN'
            || roles.indexOf('REVIEW_ADMIN') >= 0
            || roles.indexOf('ADJUDICATOR') >= 0;
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: '이견조정 처리 실패',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
    }

    private newKey(prefix: string, resourceId: string) {
        return prefix + '-' + resourceId.substring(0, 8) + '-'
            + Date.now().toString(36) + '-'
            + Math.random().toString(36).substring(2, 10);
    }

    private initializeForms() {
        let forms: any = {};
        for (let item of this.items) {
            let resolution = item.resolution || {};
            let annotation = resolution.annotation
                || ((item.decisions || [])[0] || {}).annotation
                || {};
            forms[item.candidate_id] = {
                final_decision: resolution.final_decision || '',
                final_revision_id: resolution.final_revision
                    ? resolution.final_revision.id
                    : '',
                reason_codes: (resolution.reason_codes || []).slice(),
                comment: resolution.comment || '',
                domain_code: annotation.domain_code || '',
                difficulty_code: annotation.difficulty_code || '',
                rfp_qa_type: annotation.rfp_qa_type || '',
                idempotency_key: this.newKey('adjudication', item.candidate_id)
            };
        }
        this.forms = forms;
    }

    public async load() {
        if (!this.currentDataset().dataset_id || !this.canAdjudicate()) {
            this.loading = false;
            return;
        }
        this.loading = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/reviews/adjudications/list', {
                dataset_id: this.currentDataset().dataset_id,
                batch_id: this.selectedBatchId
            });
            if (result.code !== 200) {
                await this.showError(result.data && result.data.message ? result.data.message : '이견조정 항목을 불러오지 못했습니다.');
                return;
            }
            this.batches = result.data.batches || [];
            this.selectedBatchId = result.data.selected_batch_id || '';
            this.items = result.data.items || [];
            this.policy = result.data.policy || {};
            this.canClose = !!result.data.can_close;
            this.initializeForms();
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async changeBatch() {
        await this.load();
    }

    public selectedBatch() {
        return this.batches.find((batch: any) => batch.id === this.selectedBatchId);
    }

    public formFor(candidateId: string) {
        return this.forms[candidateId] || {};
    }

    public async selectFinal(candidateId: string, decision: string) {
        let form = this.formFor(candidateId);
        form.final_decision = decision;
        if (decision !== 'EDIT_APPROVE') form.final_revision_id = '';
        if (decision !== 'REJECT') form.reason_codes = [];
        await this.service.render();
    }

    public reasonSelected(candidateId: string, reasonCode: string) {
        return (this.formFor(candidateId).reason_codes || []).indexOf(reasonCode) >= 0;
    }

    public async toggleReason(candidateId: string, reasonCode: string) {
        let form = this.formFor(candidateId);
        let reasons = form.reason_codes || [];
        let index = reasons.indexOf(reasonCode);
        if (index >= 0) reasons.splice(index, 1);
        else reasons.push(reasonCode);
        form.reason_codes = reasons.slice();
        await this.service.render();
    }

    public stateLabel(value: string) {
        let labels: any = {
            PENDING: '검수 미완료',
            AGREED: '판정 합의',
            HOLD: '보류',
            CONFLICT: '판정 충돌',
            RESOLVED: '조정 완료'
        };
        return labels[value] || value;
    }

    public decisionLabel(value: string) {
        let labels: any = {
            APPROVE: '승인',
            EDIT_APPROVE: '수정 후 승인',
            HOLD: '보류',
            REJECT: '반려'
        };
        return labels[value] || value;
    }

    public annotationLabel(group: string, value: string) {
        let annotation = this.policy.annotation || {};
        let matched = (annotation[group] || []).find(
            (option: any) => option.value === value
        );
        return matched ? matched.label : value;
    }

    public batchStatusLabel(value: string) {
        let labels: any = {
            IN_PROGRESS: '독립검수 진행',
            REVIEWED: '독립검수 완료',
            ADJUDICATING: '이견조정',
            CLOSED: '종료'
        };
        return labels[value] || value;
    }

    public async submit(item: any) {
        if (this.savingCandidateId) return;
        let form = this.formFor(item.candidate_id);
        if (!form.final_decision) {
            await this.showError('최종 판정을 선택해 주세요.');
            return;
        }
        if (form.final_decision === 'EDIT_APPROVE' && !form.final_revision_id) {
            await this.showError('최종 반영할 Revision을 선택해 주세요.');
            return;
        }
        if (form.final_decision === 'REJECT' && !(form.reason_codes || []).length) {
            await this.showError('최종 반려에는 하나 이상의 사유가 필요합니다.');
            return;
        }
        if (form.final_decision === 'EDIT_APPROVE' && form.comment.trim().length < 2) {
            await this.showError('수정안 선택 사유를 2자 이상 입력해 주세요.');
            return;
        }
        if ((form.final_decision === 'APPROVE' || form.final_decision === 'EDIT_APPROVE')
            && (!form.domain_code || !form.difficulty_code || !form.rfp_qa_type)) {
            await this.showError('최종 승인 항목의 분야·난이도·RFP QA 유형을 모두 선택해 주세요.');
            return;
        }

        this.savingCandidateId = item.candidate_id;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/reviews/adjudications/submit', {
                dataset_id: this.currentDataset().dataset_id,
                batch_id: this.selectedBatchId,
                candidate_id: item.candidate_id,
                final_decision: form.final_decision,
                final_revision_id: form.final_revision_id,
                reason_codes: (form.reason_codes || []).join(','),
                comment: form.comment,
                domain_code: form.domain_code,
                difficulty_code: form.difficulty_code,
                rfp_qa_type: form.rfp_qa_type,
                idempotency_key: form.idempotency_key
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.showError(result.data && result.data.message ? result.data.message : '최종 판정을 저장하지 못했습니다.');
                return;
            }
            await this.load();
            await this.service.modal.show({
                title: '이견조정 저장 완료',
                message: this.decisionLabel(result.data.item.resolution.final_decision) + '으로 최종 판정했습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
        } finally {
            this.savingCandidateId = '';
            await this.service.render();
        }
    }

    public async closeBatch() {
        if (this.closing || !this.canClose) return;
        let batch = this.selectedBatch();
        let confirmed = await this.service.modal.show({
            title: 'Review Batch 종료',
            message: batch.name + '의 판정과 Revision 선택을 확정합니다. 종료 후 검수 판정은 변경할 수 없습니다.',
            cancel: '취소',
            action: '종료',
            actionBtn: 'success',
            status: 'success'
        });
        if (!confirmed) return;

        this.closing = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/reviews/adjudications/close', {
                dataset_id: this.currentDataset().dataset_id,
                batch_id: this.selectedBatchId,
                idempotency_key: this.newKey('close-batch', this.selectedBatchId)
            });
            if (result.code !== 200) {
                await this.showError(result.data && result.data.message ? result.data.message : 'Review Batch를 종료하지 못했습니다.');
                return;
            }
            let revisionSet = result.data.approved_revision_set;
            await this.load();
            await this.service.modal.show({
                title: 'Review Batch 종료 완료',
                message: '승인 ' + revisionSet.accepted_items.length + '건, 반려 ' + revisionSet.rejected_items.length + '건을 확정했습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
        } finally {
            this.closing = false;
            await this.service.render();
        }
    }
}

export default PageAuthoringAdjudicationsComponent;